<style src="./UsageDensity.scss" lang="scss"></style>
<template>
  <div>
    <form @submit.prevent="sendCampaign" class="formcontainer">
      <div class="inputcontainer">
        <div class="inputcontent">
          <label>Digite o inicio do periodo</label>
          <input
            type="datetime-local"
            :min="initialDateLimit"
            :max="initialDateLimit"
            class="form-control"
            v-model="form.dateTimeInitial"
          />
        </div>
        <div class="inputcontent">
          <label>Digite o fim do periodo</label>
          <input
            type="datetime-local"
            :min="initialDateLimit"
            :max="initialDateLimit"
            class="form-control"
            v-model="form.dateTimeFinal"
          />
        </div>
      </div>
      <div class="input-group-btn">
        <button
          type="button"
          class="btn btn-lg btn-primary "
          @click="loadMarkers"
        >
          <i class="fa fa-search"></i>
          Buscar
        </button>
      </div>
    </form>
    <GmapMap
      class="mapcontainer"
      :center="center"
      :zoom="16"
      :options="mapOptions"
    >
      <gmap-heatmap-layer
        :data="markers"
        :options="{
          dissipating: true,
          radius: 100,
          opacity: 0.7,
        }"
      />
    </GmapMap>
  </div>
</template>

<script>
import { gmapApi } from "gmap-vue";
import { format } from "date-fns";
export default {
  name: "ParkingMap",
  data: () => ({
    center: { lat: -22.4732992, lng: -43.8566519 },
    markers: [],
    mapStyles: [
      {
        featureType: "poi",
        elementType: "labels",
        stylers: [{ visibility: "off" }],
      },
    ],
    form: {
      dateTimeInitial: "",
      dateTimeFinal: "",
    },
    initialDateLimit: format(new Date(), "yyyy-MM-dd'T'HH:mm:ss"),
  }),
  computed: {
    google: gmapApi,
    mapOptions() {
      return {
        styles: this.mapStyles,
      };
    },
  },
  methods: {
    async loadMarkers() {
      if (
        this.form.dateTimeInitial.length === 0 ||
        this.form.dateTimeFinal.length === 0
      ) {
        return;
      }
      try {
        const parkings = await this.$store.dispatch(
          "PARKING/GetParkUsageLocation",
          {
            dateTimeInitial: this.form.dateTimeInitial,
            dateTimeFinal: this.form.dateTimeFinal,
          }
        );

        const formattedParks = parkings.map((parkInfo) => ({
          location: new this.google.maps.LatLng({
            lat: parkInfo.location[0],
            lng: parkInfo.location[1],
          }),
          weight: parkInfo.occupation,
          parkName: parkInfo.name,
          parkingSpaceCount: parkInfo.parkingSpaceCount,
        }));

        this.markers = formattedParks;
      } catch (error) {
        console.error(error);
        this.$toasted.error("Não foi possível listar os estacionamentos");
      }
    },
  },
};
</script>
